import React from 'react';
import { observer } from 'mobx-react-lite';
import Popup from '../../../../../components/common-components/pop-up/Popup';
import CommonButton from '../../../../../components/common-components/button/CommonButton';
import './DeleteConfirmationDialog.css';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Silme Onayı',
}) => {
  const handleConfirmClick = () => {
    onConfirm();
  };

  const handleCancelClick = () => {
    onClose();
  };

  return (
    <Popup isOpen={isOpen} onClose={onClose} title={title}>
      <div className="delete-confirmation-container">
        <p>Bu öğeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</p>

        <div className="delete-confirmation-buttons">
          <CommonButton type="secondary" onClick={handleCancelClick}>
            Hayır
          </CommonButton>
          <CommonButton type="primary" onClick={handleConfirmClick}>
            Evet
          </CommonButton>
        </div>
      </div>
    </Popup>
  );
};

export default observer(DeleteConfirmationDialog);
